export default "assets/images/stars-888e7dd7.png";